<template>
    <v-container grid-list-lg class="consulta-itens pa-0 ma-0" fluid>
        <v-layout row wrap>
            <v-flex xs12 sm12 md12 lg12 class="pt-0 pb-0">
            <v-card
                flat
                :style="
                !$vuetify.breakpoint.smAndDown
                    ? 'padding-left: 30px; padding-right: 30px;'
                    : 'padding-top: 15px; padding-bottom: 10px;'
                "
            >
                <v-card-title class="pt-0 pb-0">
                <v-layout
                    row
                    wrap
                    :align-center="$vuetify.breakpoint.smAndUp"
                    :align-content-center="$vuetify.breakpoint.smAndDown"
                >
              
                <v-flex class="flex-menu-container my-2" xs12 sm11 md12 lg4>
                    <v-btn
                        color="primary"
                        round
                        flat
                        :outline="true"
                        @click="dialogFiltroConsulta = true"
                        :block="$vuetify.breakpoint.smAndDown"
                    >
                  FILTRO</v-btn
                >
                </v-flex>
                
  
              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12 class="pt-0 pb-0">
          <v-card
            flat
            :style="
              !$vuetify.breakpoint.smAndDown
                ? 'padding-left: 30px; padding-right: 30px;'
                : 'padding-top: 15px; padding-bottom: 10px;'
            "
          >
            <v-card-title class="pt-0 pb-0">
              <v-layout
                row
                wrap
                :align-center="$vuetify.breakpoint.smAndUp"
                :align-content-center="$vuetify.breakpoint.smAndDown"
              >
                <v-spacer></v-spacer>
              </v-layout>
            </v-card-title>
          </v-card>
        </v-flex>
       
      </v-layout>
  
      <div style="padding:30px 50px">
       
        
        <template>
          <div>
            <v-data-table
              :headers="headers"
              :items="listaItens"
              hide-actions
              :rows-per-page-items="[10]"
              item-key="item"
              class="elevation-1 table-grid"
            >
              <template  v-slot:items="props">
                <td class="linhas-tabela">{{props.item.placa}}</td>
                <td class="linhas-tabela">{{props.item.chassi}}</td>
                <td class="linhas-tabela">{{props.item.proponenteRazaoSocial}}</td>
                <td class="linhas-tabela">{{props.item.proponenteCnpj}}</td>
                <td class="linhas-tabela">{{props.item.apoliceNumeroProposta}}</td>
                <td class="linhas-tabela">{{props.item.apoliceNumeroCotacao}}</td>
                <td class="linhas-tabela">{{props.item.situacaoApolice}}</td>
                <td class="linhas-tabela">{{props.item.statusApolice}}</td>
                <td class="linhas-tabela">{{props.item.statusVinculo}}</td>
                <td class="linhas-tabela">{{ formatarData(props.item.dataInicio)}}</td>
                <td class="linhas-tabela">{{ formatarData(props.item.dataFim)}}</td>

              </template>
              <template slot="no-data">
                <p style="margin: 15px 0;font-size: 18px;  text-align:center">Use o botão Filtro para consultar os Itens.</p>
            </template>
            </v-data-table>
            <div class="text-xs-center pt-2">
              <v-pagination
                v-model="paginacao.page"
                :length="paginacao.totalPages"
                circle
              ></v-pagination>
            </div>
          </div>
        </template>
        <v-snackbar
          :timeout="3000"
          :color="snackbar.sucesso ? 'success' : 'error'"
          multi-line
          v-model="snackbar.visivel"
        >
          {{ snackbar.mensagem }}
          <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
        </v-snackbar>
        <template>
       
    </template>
    </div>
    <v-dialog
        v-model="dialogFiltroConsulta"
        width="250"
    >
        <v-card class="dialog-filtro-consulta ">
            <v-card-title
                class="headline lighten-2 pa-3"
                primary-title
                style="color: #757575; font-size: 18px"
            >
                Filtro
            </v-card-title>
            <v-divider></v-divider>
            <v-container>
                <v-text-field label="Chassi" v-model="consultaItensForm.chassi"></v-text-field>
                <v-text-field label="Placa" v-model="consultaItensForm.placa"></v-text-field>

            
                <v-btn class="primary" @click="consultarItensLista" :disabled="disableConsultarItens" block>CONSULTAR</v-btn>
            </v-container>

            <v-divider></v-divider>

            <v-card-actions class="flex-special-container pa-2">
              
                <v-btn
                    color="primary"
                    flat
                    style="color:#2B8FE7!important"
                    @click="dialogFiltroConsulta = false"
                >
                    Fechar
                </v-btn>
                <v-btn
                    color="primary"
                    flat
                    @click="limparFormConsulta"
                    style="color:#2B8FE7!important"
                >
                    Limpar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</v-container>

  </template>

<script>
import axios from 'axios';
import usuarioHelper from "@/helpers/usuario-logado.js";

    export default {
        name: "GridConsultaItens",
        data() {
            return {
                disableConsultarItens: true, 
                consultaItensForm: {
                    chassi: null,
                    placa: null,
                },
                
                dialogFiltroConsulta: false, 
                dialogErros: false,
                listaItens: [],
                dialog: false,
                loading: false,
                selected: null,
                
                paginacao: {
                    page: parseInt(sessionStorage.getItem('pageGridConsultaItens')),
                    size: 10,
                    totalPages: 1,
                },
                snackbar: {
                    visivel: false,
                    sucesso: false,
                    mensagem: ""
                },
                headers: [
                    { text: "Placa", value: "placa", align:'center' },
                    { text: "Chassi", value: "chassi", align:'center' },
                    { text: "Razão Social", value: "proponenteRazaoSocial", align:'center' },
                    { text: "CNPJ", value: "proponenteCnpj", align:'center' },
                    { text: "Nº da Proposta", value: "nrProposta", align:'center' },
                    { text: "Cód. Cotação", value: "apoliceNumeroCotacao", align:'center' },
                    { text:"Situação da Apolice", value:"situacao",  align:'center'},
                    { text:"Status Apolice", value:"statusApolice",  align:'center'},
                    { text:"Status Vigência", value:"statusApolice",  align:'center'},
                    { text:"Inicio da Vigência", value:"inicioVigencia",  align:'center'},
                    { text:"Fim da Vigência", value:"fimVigencia",  align:'center'},
                ],
            }
        },
        mounted() {
            if(sessionStorage.getItem('pageGridConsultaItens') == null ) {
                this.paginacao.page = 1;
            }
        },
        computed: {
            
        },
        watch: 
        
                {
            "paginacao.page"(val) {
                this.$store.commit("startLoading");
                this.buscarItensLista();
                sessionStorage.setItem('pageGridConsultaItens',val);
                this.$store.commit("endLoading");

            },
            "paginacao.size"() {
                this.buscarListaItens();
            },
            "consultaItensForm.chassi"(val) {
                
                if(val) {
                    if(val.length > 0) {
                        this.disableConsultarItens = false;
                    }
                }
                if((this.consultaItensForm.chassi == null || this.consultaItensForm.chassi == "") && (this.consultaItensForm.placa == null || this.consultaItensForm.placa == "")) {
                    this.disableConsultarItens = true;
                    

                } 
                if(this.consultaItensForm.chassi == null || this.consultaItensForm.chassi == "") {
                    this.consultaItensForm.chassi = null;
                }

            },
            "consultaItensForm.placa"(val) {
                if(val) {
                    if(val.length > 0) {
                        this.disableConsultarItens = false;
                    }
                }
                if((this.consultaItensForm.chassi == null || this.consultaItensForm.chassi == "") && (this.consultaItensForm.placa == null || this.consultaItensForm.placa == "")) {
                    this.disableConsultarItens = true;
                }
                if(this.consultaItensForm.placa == null || this.consultaItensForm.placa == ""){
                    this.consultaItensForm.placa = null;

                }
            }
        },
        methods: {
            formatarData(data) {
            if (data) {
                return new Date(data).toLocaleDateString("pt-BR", {
                    timeZone: "UTC",
                    year: "numeric",
                    month: "numeric",
                    day: "numeric",
                });
            }
    },
            consultarItensLista() {
                this.$store.commit("startLoading");
                this.buscarItensLista();
                this.dialogFiltroConsulta = false;
                this.$store.commit("endLoading");

            },
            buscarItensLista() {
                axios.get(`${process.env.URL_CONSULTARITENSMS}/v1/consultaItensChassi/${this.consultaItensForm.chassi}/${this.consultaItensForm.placa}?page=${this.paginacao
                .page - 1}&size=${this.paginacao.size}`, {
                    headers: {
                        Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
                    }
                })
                .then(res => {
                    this.listaItens = res.data.content;
                    this.paginacao.totalPages = res.data.totalPages;
                })
                .catch(err => {
                    this.snackbar.visivel = true;
                    this.snackbar.sucesso = false; 
                    this.snackbar.mensagem = err.response.data.message;
                })
            },
            limparFormConsulta() {
                this.consultaItensForm.chassi = null;
                this.consultaItensForm.placa = null;
            },
            
        },
    }
</script>
<style>
.consulta-itens .theme--light.v-table thead tr:first-child{
    background-color: #00456e;
}
.consulta-itens .v-datatable thead th.column {
    color: #FFF!important;
}
.consulta-itens .theme--light.v-datatable thead th.column.sortable.active .v-icon {
    color: #FFF;
}
.dialog-filtro-consulta {
    border-radius: 10px;
}
.consulta-itens .v-dialog {
    border-radius: 10px;
}
.flex-special-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.flex-menu-container {
    display: flex;
    align-items: center;
}
.linhas-tabela  {
    text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/consulta-itens/GridConsultaItens.vue